import React, { useContext } from 'react';
import { bool } from 'prop-types';
import classNames from 'classnames';
import { Col, Image } from '@thd-olt-component-react/core-ui';
import { OrderAPackageContext } from '../../OrderAPackageContext';
import { TotalPricing } from '../subcomponents/totalPricing/TotalPricing';
import { OrderAPackageBuyBox } from '../subcomponents/orderAPackageBuyBox/OrderAPackageBuyBox';
import { ProductImage } from '../subcomponents/productImage/ProductImage';
import './header.scss';

export const Header = ({ card, landscape } = {}) => {
  const { state } = useContext(OrderAPackageContext);
  if (!state?.metadata) return null;
  const { totalPricing, metadata, selectedProductIds } = state;
  const {
    brandImage,
    brandName,
    image,
    name
  } = metadata;
  const packageImage = image?.url;
  const parentClassNames = classNames('header', { card, 'header--landscape': landscape, 'header--main': !landscape });
  const headerContentClassNames = classNames('header__content', { 'header__content--landscape': landscape });
  const scrollToItem = (event = {}) => {
    const elementId = event.currentTarget?.id;
    const itemToScrollTo = document.getElementById(`package-pod--${elementId}`);
    // eslint-disable-next-line no-unused-expressions
    itemToScrollTo?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return (
    <section className={parentClassNames}>
      <Col flatten>
        <div className={headerContentClassNames}>
          <div className="header__content__brand-logo">
            {(brandImage?.url || packageImage) && (
              <Image
                src={brandImage?.url || packageImage}
                alt={`${brandName} logo.`}
                width={12}
                height={7}
              />
            )}
          </div>
          <div className="header__content__information">
            <div className="header__content__description">
              <div className="header__content__description__name">
                <h1> <span> {name} </span></h1>
                {totalPricing.hasBundleSavings && (
                  <div className="header__content__description__subtitle">
                    <Image
                      className="header__content__description__subtitle-icon"
                      asset="savings-tag.svg"
                      alt="Savings Tag"
                      title="Savings Tag"
                    />
                    <h3 className="header__content__description__subtitle-text">
                      Special Price When Bundled Together
                    </h3>
                  </div>
                )}
              </div>
            </div>
            {landscape && !!selectedProductIds.length && (
              <Col className="header__items-container" nopadding>
                {
                  (Array.from(state.products.values()) || []).map((product, index) => {
                    const { images } = product?.media;
                    const { selected, productGroupSelected, identifiers } = product;
                    const { canonicalUrl, productLabel, brandName: itemBrandName, itemId } = identifiers;
                    return (selected && productGroupSelected &&
                      (
                        <Col key={index} className="header__item" id={itemId} onClick={scrollToItem}>
                          <ProductImage
                            canonicalUrl={canonicalUrl}
                            productLabel={productLabel}
                            brandName={itemBrandName}
                            images={images}
                            landscape
                            stickyHeader
                            disableLink
                          />
                        </Col>
                      )
                    );
                  })
                }
              </Col>
            )}
            <div className="header__content__price">
              <TotalPricing totalValue resize nopadding />
            </div>
          </div>
        </div>
      </Col>
      <div className="header__content__add-to-cart-button">
        {!!totalPricing.totalValueRaw &&
          (
            <OrderAPackageBuyBox landscape={landscape} forHeader />
          )}
      </div>
    </section>
  );
};

Header.propTypes = {
  card: bool,
  landscape: bool
};

Header.defaultProps = {
  card: false,
  landscape: false
};

Header.displayName = 'Header';
